import { showInputError } from "../../../shared/input-handler";
export class Oral {
    constructor(form) {
        this.start = form.querySelector("input.js-oral-start");
        this.end = form.querySelector("input.js-oral-end");
    }
    addToFormData(formData) {
        formData.append(this.start.name, this.start.value);
        formData.append(this.end.name, this.end.value);
    }
    validate() {
        return (this.start.value === "" || this.end.value === "" || this.checkDateOrder());
    }
    checkDateOrder() {
        const startDate = this.createDate(this.start.value);
        const endDate = this.createDate(this.end.value);
        const days = (endDate.getTime() - startDate.getTime()) / (60 * 60 * 1000);
        if (days < 0) {
            showInputError(this.end, incorrectOralFinal);
            return false;
        }
        return true;
    }
    createDate(dateString) {
        const date = new Date(dateString.replace(/(\d{2})-(\d{2})-(\d{4})/, "$3-$2-$1"));
        if (isNaN(date.getTime())) {
            throw new Error("Invalid date format");
        }
        return date;
    }
}
